import { SessionPages } from '@heidi/schema/ml-scribe';
import { useCallback, useMemo } from 'react';
import { useTutorial } from '../useTutorial';

export const useTutorialActions = () => {
  const { tutorialStepCurrentPage, onNextPage, panelOpen } = useTutorial();

  const highlightStart =
    tutorialStepCurrentPage?.enum === SessionPages.RUN_CONSULT && panelOpen;

  const highlightStop =
    tutorialStepCurrentPage?.enum === SessionPages.STOP_SESSION && panelOpen;

  const onStart = useCallback(() => {
    if (highlightStart) onNextPage();
  }, [highlightStart, onNextPage]);

  const onStop = useCallback(() => {
    if (highlightStop) onNextPage();
  }, [highlightStop, onNextPage]);

  return useMemo(() => ({ onStart, onStop }), [onStart, onStop]);
};
